function onFilterChange(params) {
    const filterObj = { ...params.items[0] }
    var value = ""
    switch (filterObj.operator) {
        case "isEmpty":
            value = "isEmpty"
            break
        case "isNotEmpty":
            value = "isNotEmpty"
            break
        default:
            break
    }
    if (value === "" && (filterObj.field === undefined || filterObj.value === undefined)) {
        return {}
    }
    if (value === "") {
        switch (filterObj.operator) {
            case "contains":
                value = "ilike"
                break
            case "!=":
            case "not":
                value = "ne"
                break
            case "=":
            case "equals":
            case "is":
                value = "eq"
                break
            case ">":
                value = "gt"
                break
            case ">=":
                value = "gte"
                break
            case "<":
                value = "lt"
                break
            case "startsWith":
                value = "startsWith"
                break
            case "endsWith":
                value = "endsWith"
                break
            case "isAnyOf":
                value = "in"
                if (filterObj.value.length === 0) {
                    return {}
                }
                break
            default:
                value = "lte"
        }
    }
    const key = filterObj.field + "." + value
    const filter = { [key]: filterObj.value ?? '' }
    return filter
}
export default onFilterChange
